import creatorComponent from './creator.component';
import creatorCurveComponent from './curve.component';
import creatorDataComponent from './data.component';
import creatorSnowDataComponent from './snow-data.component';


const imomoStationCreatorModule = angular.module('imomo.station.creator', [])
    .component('imomoStationCreator', creatorComponent)
    .component('imomoStationCreatorCurve', creatorCurveComponent)
    .component('imomoStationCreatorData', creatorDataComponent)
    .component('imomoStationCreatorSnowData', creatorSnowDataComponent)

export default imomoStationCreatorModule;



/** WEBPACK FOOTER **
 ** ./app/station/creator/creator.module.ts
 **/